var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "overflow-x": "scroll"
    }
  }, [!_vm.title ? _c('v-card-title', [_vm._v(" База актов и выплат "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.forceUpdate
    }
  }, [_c('v-icon', [_vm._v("mdi-reload")])], 1), _c('v-spacer'), _c('div', [_vm.$helper.permission.canUpdateContract(_vm.user) ? _c('ActDialog', {
    attrs: {
      "lawyers": _vm.lawyers,
      "lawyersOGPA": _vm.lawyersOGPA,
      "lawyersEPO": _vm.lawyersEPO,
      "actTypes": _vm.actTypes
    },
    on: {
      "saved": _vm.onItemAdd
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm.title ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('v-data-table', {
    staticClass: "elevation-1",
    style: `min-width: ${_vm.getTableWidth()}`,
    attrs: {
      "headers": _vm.headers,
      "items": _vm.acts,
      "options": _vm.actGridsOptions.options,
      "server-items-length": _vm.totalElements,
      "item-key": "id",
      "loading": _vm.loading,
      "loading-text": "Загрузка ...",
      "footer-props": {
        'items-per-page-options': _vm.itemPerPage
      },
      "fixed-header": _vm.fixedHeader,
      "height": _vm.tableHeight
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.actGridsOptions, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref) {
        var items = _ref.items;
        return [_c('tbody', [!_vm.filter ? _c('tr', {
          staticClass: "row_sticky"
        }, [_c('td', {
          staticClass: "px-2",
          attrs: {
            "width": "20"
          }
        }), _vm.isVisibleColumn('inFavorites') ? _c('td', {
          staticClass: "pr-0",
          attrs: {
            "width": "30"
          }
        }, [_c('v-checkbox', {
          staticClass: "ma-0",
          attrs: {
            "value": _vm.user.id,
            "hide-details": ""
          },
          model: {
            value: _vm.actGridsOptions.filter['usersAddToFavorites[0].id'],
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, 'usersAddToFavorites[0].id', $$v);
            },
            expression: "actGridsOptions.filter['usersAddToFavorites[0].id']"
          }
        })], 1) : _vm._e(), _c('td', {
          attrs: {
            "width": "60"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.id,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "id", $$v);
            },
            expression: "actGridsOptions.filter.id"
          }
        })], 1), _vm.isVisibleColumn('date') ? _c('td', {
          attrs: {
            "width": "130"
          }
        }, [_c('v-dialog', {
          ref: "dialogDates",
          attrs: {
            "return-value": _vm.actGridsOptions.filter.dates,
            "persistent": "",
            "width": "290px"
          },
          on: {
            "update:returnValue": function ($event) {
              return _vm.$set(_vm.actGridsOptions.filter, "dates", $event);
            },
            "update:return-value": function ($event) {
              return _vm.$set(_vm.actGridsOptions.filter, "dates", $event);
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var on = _ref2.on;
              return [_c('v-text-field', _vm._g({
                attrs: {
                  "prepend-icon": "mdi-calendar-month-outline",
                  "readonly": "",
                  "clearable": ""
                },
                model: {
                  value: _vm.actGridsOptions.filter.dates,
                  callback: function ($$v) {
                    _vm.$set(_vm.actGridsOptions.filter, "dates", $$v);
                  },
                  expression: "actGridsOptions.filter.dates"
                }
              }, on))];
            }
          }], null, true),
          model: {
            value: _vm.dialog.dates.modal,
            callback: function ($$v) {
              _vm.$set(_vm.dialog.dates, "modal", $$v);
            },
            expression: "dialog.dates.modal"
          }
        }, [_c('v-date-picker', {
          attrs: {
            "type": "date",
            "scrollable": "",
            "range": "",
            "first-day-of-week": "1"
          },
          model: {
            value: _vm.dialog.dates.model,
            callback: function ($$v) {
              _vm.$set(_vm.dialog.dates, "model", $$v);
            },
            expression: "dialog.dates.model"
          }
        }, [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "text": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.dialog.dates.modal = false;
            }
          }
        }, [_vm._v("Отмена")]), _c('v-btn', {
          attrs: {
            "text": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.$refs.dialogDates.save(_vm.dialog.dates.model);
            }
          }
        }, [_vm._v(" Выбрать ")])], 1)], 1)], 1) : _vm._e(), _vm.isVisibleColumn('signDate') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }, [_c('v-dialog', {
          ref: "dialogSignDates",
          attrs: {
            "return-value": _vm.actGridsOptions.filter.signDates,
            "persistent": "",
            "width": "290px"
          },
          on: {
            "update:returnValue": function ($event) {
              return _vm.$set(_vm.actGridsOptions.filter, "signDates", $event);
            },
            "update:return-value": function ($event) {
              return _vm.$set(_vm.actGridsOptions.filter, "signDates", $event);
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref3) {
              var on = _ref3.on;
              return [_c('v-text-field', _vm._g({
                attrs: {
                  "prepend-icon": "mdi-calendar-month-outline",
                  "readonly": "",
                  "clearable": ""
                },
                model: {
                  value: _vm.actGridsOptions.filter.signDates,
                  callback: function ($$v) {
                    _vm.$set(_vm.actGridsOptions.filter, "signDates", $$v);
                  },
                  expression: "actGridsOptions.filter.signDates"
                }
              }, on))];
            }
          }], null, true),
          model: {
            value: _vm.dialog.signDates.modal,
            callback: function ($$v) {
              _vm.$set(_vm.dialog.signDates, "modal", $$v);
            },
            expression: "dialog.signDates.modal"
          }
        }, [_c('v-date-picker', {
          attrs: {
            "type": "date",
            "scrollable": "",
            "range": "",
            "first-day-of-week": "1"
          },
          model: {
            value: _vm.dialog.signDates.model,
            callback: function ($$v) {
              _vm.$set(_vm.dialog.signDates, "model", $$v);
            },
            expression: "dialog.signDates.model"
          }
        }, [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "text": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.dialog.signDates.modal = false;
            }
          }
        }, [_vm._v("Отмена")]), _c('v-btn', {
          attrs: {
            "text": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.$refs.dialogSignDates.save(_vm.dialog.signDates.model);
            }
          }
        }, [_vm._v(" Выбрать ")])], 1)], 1)], 1) : _vm._e(), _vm.isVisibleColumn('type') ? _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.actTypes,
            "clearable": "",
            "item-value": "value",
            "item-text": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.type,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "type", $$v);
            },
            expression: "actGridsOptions.filter.type"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('number') ? _c('td', {
          attrs: {
            "width": "80"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.number,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "number", $$v);
            },
            expression: "actGridsOptions.filter.number"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.number') ? _c('td', {
          attrs: {
            "width": "100"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.contract.number,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter.contract, "number", $$v);
            },
            expression: "actGridsOptions.filter.contract.number"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.date') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }, [_c('DateField', {
          attrs: {
            "label": "",
            "clearable": true,
            "range": true
          },
          model: {
            value: _vm.actGridsOptions.filter.contract.dates,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter.contract, "dates", $$v);
            },
            expression: "actGridsOptions.filter.contract.dates"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.type') ? _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.types,
            "clearable": "",
            "item-value": "value",
            "item-text": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.contract.type,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter.contract, "type", $$v);
            },
            expression: "actGridsOptions.filter.contract.type"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.subject') ? _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.subjects,
            "clearable": "",
            "item-value": "value",
            "item-text": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.contract.subject,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter.contract, "subject", $$v);
            },
            expression: "actGridsOptions.filter.contract.subject"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.client') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "text"
          },
          model: {
            value: _vm.actGridsOptions.filter.contract.userName,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter.contract, "userName", $$v);
            },
            expression: "actGridsOptions.filter.contract.userName"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.lawyer') ? _c('td', {
          attrs: {
            "width": "130"
          }
        }, [_c('v-select', {
          attrs: {
            "multiple": "",
            "items": _vm.lawyers,
            "clearable": "",
            "item-value": "id",
            "item-text": "fullName"
          },
          model: {
            value: _vm.actGridsOptions.filter.lawyers,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "lawyers", $$v);
            },
            expression: "actGridsOptions.filter.lawyers"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('lawyerAssistant') ? _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_c('v-select', {
          attrs: {
            "multiple": "",
            "items": _vm.lawyers,
            "clearable": "",
            "item-value": "id",
            "item-text": "fullName"
          },
          model: {
            value: _vm.actGridsOptions.filter.lawyerAssistants,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "lawyerAssistants", $$v);
            },
            expression: "actGridsOptions.filter.lawyerAssistants"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('contract.lawyerOGPA') ? _c('td', {
          attrs: {
            "width": "130"
          }
        }, [_c('v-select', {
          attrs: {
            "multiple": "",
            "items": _vm.lawyersOGPA,
            "clearable": "",
            "item-value": "id",
            "item-text": "fullName"
          },
          model: {
            value: _vm.actGridsOptions.filter.contract.lawyerOGPAs,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter.contract, "lawyerOGPAs", $$v);
            },
            expression: "actGridsOptions.filter.contract.lawyerOGPAs"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('lawyerEPO') ? _c('td', {
          attrs: {
            "width": "130"
          }
        }, [_c('v-select', {
          attrs: {
            "multiple": "",
            "items": _vm.lawyersEPO,
            "clearable": "",
            "item-value": "id",
            "item-text": "fullName"
          },
          model: {
            value: _vm.actGridsOptions.filter.lawyerEPOs,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "lawyerEPOs", $$v);
            },
            expression: "actGridsOptions.filter.lawyerEPOs"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('lawyerOGPA') ? _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_c('v-select', {
          attrs: {
            "multiple": "",
            "items": _vm.lawyersOGPA,
            "clearable": "",
            "item-value": "id",
            "item-text": "fullName"
          },
          model: {
            value: _vm.actGridsOptions.filter.lawyerOGPAs,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "lawyerOGPAs", $$v);
            },
            expression: "actGridsOptions.filter.lawyerOGPAs"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('amountAct') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }) : _vm._e(), _vm.isVisibleColumn('amountAct') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }) : _vm._e(), _vm.canSeeActBonus() ? _c('td', {
          attrs: {
            "width": "200"
          }
        }) : _vm._e(), _vm.isVisibleColumn('amountPayout') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }) : _vm._e(), _vm.isVisibleColumn('amount') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }) : _vm._e(), _vm.isVisibleColumn('remainder') ? _c('td', {
          attrs: {
            "width": "100"
          }
        }) : _vm._e(), _vm.isVisibleColumn('createdBy') ? _c('td', {
          attrs: {
            "width": "100"
          }
        }) : _vm._e(), _vm.isVisibleColumn('installment') ? _c('td', {
          attrs: {
            "width": "120"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.installments,
            "clearable": "",
            "item-value": "id",
            "item-text": "name"
          },
          model: {
            value: _vm.actGridsOptions.filter.installment,
            callback: function ($$v) {
              _vm.$set(_vm.actGridsOptions.filter, "installment", $$v);
            },
            expression: "actGridsOptions.filter.installment"
          }
        })], 1) : _vm._e(), _vm.isVisibleColumn('comment') ? _c('td', {
          attrs: {
            "width": "230"
          }
        }) : _vm._e()]) : _vm._e(), _vm._l(items, function (item, key) {
          var _item$contract, _item$contract2, _item$contract3, _item$contract4, _item$contract5, _item$contract6, _item$type, _item$type2, _item$type3, _item$type4;
          return _c('tr', {
            key: item.id,
            class: {
              'grey darken-3': _vm.isHighlighted(item)
            }
          }, [_c('td', {
            staticClass: "pl-5 pr-3"
          }, [_vm.$helper.permission.canDeleteAct(item, _vm.user) ? _c('v-dialog', {
            attrs: {
              "max-width": "320"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (_ref4) {
                var on = _ref4.on;
                return [_c('v-icon', _vm._g({
                  attrs: {
                    "small": "",
                    "color": "red"
                  }
                }, on), [_vm._v("mdi-delete")])];
              }
            }], null, true),
            model: {
              value: _vm.deleteDialog[item.id],
              callback: function ($$v) {
                _vm.$set(_vm.deleteDialog, item.id, $$v);
              },
              expression: "deleteDialog[item.id]"
            }
          }, [_c('v-card', [_c('v-card-text', {
            staticClass: "text-center pt-7"
          }, [_vm._v("Удалить выбранный элемент?")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
            attrs: {
              "text": ""
            },
            on: {
              "click": function ($event) {
                _vm.deleteDialog[item.id] = false;
              }
            }
          }, [_vm._v("Отмена")]), _c('v-btn', {
            attrs: {
              "color": "red",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.deleteItem(item.id);
              }
            }
          }, [_vm._v("Удалить")])], 1)], 1)], 1) : _vm._e()], 1), _vm.isVisibleColumn('inFavorites') ? _c('td', [item.inFavorites ? _c('v-icon', {
            staticClass: "ml-1",
            attrs: {
              "color": "yellow"
            },
            on: {
              "click": function ($event) {
                return _vm.removeFromFavorites(item);
              }
            }
          }, [_vm._v(" mdi-star ")]) : _vm._e(), !item.inFavorites ? _c('v-icon', {
            staticClass: "ml-1",
            attrs: {
              "color": "grey"
            },
            on: {
              "click": function ($event) {
                return _vm.addToFavorites(item);
              }
            }
          }, [_vm._v(" mdi-star-outline ")]) : _vm._e()], 1) : _vm._e(), _c('td', [_c('a', {
            on: {
              "click": function ($event) {
                return _vm.editAct(item.id, items[key - 1], items[key + 1]);
              }
            }
          }, [_vm._v(_vm._s(item.id))])]), _vm.isVisibleColumn('date') ? _c('td', [_vm._v(" " + _vm._s(_vm.$moment(item.date).dateFormat()) + " ")]) : _vm._e(), _vm.isVisibleColumn('signDate') ? _c('td', [_vm._v(" " + _vm._s(_vm.$moment(item.signDate).dateFormat()) + " ")]) : _vm._e(), _vm.isVisibleColumn('type') ? _c('td', [item.type ? _c('div', [_vm._v(_vm._s(item.type.text))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('number') ? _c('td', [item.number ? _c('div', [_vm._v(_vm._s(item.number))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('contract.number') ? _c('td', [(_item$contract = item.contract) !== null && _item$contract !== void 0 && _item$contract.number ? _c('div', [_c('router-link', {
            attrs: {
              "to": `/contracts/${item.contract.id}/edit`
            }
          }, [_vm._v(" " + _vm._s(item.contract.number) + " ")])], 1) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('contract.date') ? _c('td', [_vm._v(" " + _vm._s(_vm.$moment((_item$contract2 = item.contract) === null || _item$contract2 === void 0 ? void 0 : _item$contract2.date).dateFormat()) + " ")]) : _vm._e(), _vm.isVisibleColumn('contract.type') ? _c('td', [(_item$contract3 = item.contract) !== null && _item$contract3 !== void 0 && _item$contract3.type ? _c('div', [_vm._v(_vm._s(_vm.getTypeName(item.contract.type)))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('contract.subject') ? _c('td', [(_item$contract4 = item.contract) !== null && _item$contract4 !== void 0 && _item$contract4.type ? _c('div', [_vm._v(_vm._s(_vm.getSubjectName(item.contract.subject)))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('contract.client') ? _c('td', [(_item$contract5 = item.contract) !== null && _item$contract5 !== void 0 && _item$contract5.client ? _c('div', [_vm._v(_vm._s(item.contract.client.userName))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('contract.lawyer') ? _c('td', [item !== null && item !== void 0 && item.lawyer ? _c('div', [_vm._v(_vm._s(item.lawyer.fullName))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('lawyerAssistant') ? _c('td', [item.lawyerAssistant ? _c('div', [_vm._v(" " + _vm._s(item.lawyerAssistant.fullName) + " ")]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('contract.lawyerOGPA') ? _c('td', [(_item$contract6 = item.contract) !== null && _item$contract6 !== void 0 && _item$contract6.lawyerOGPA ? _c('div', [_vm._v(_vm._s(item.contract.lawyerOGPA.fullName))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('lawyerEPO') ? _c('td', [item.lawyerEPO ? _c('div', [_vm._v(_vm._s(item.lawyerEPO.fullName))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('lawyerOGPA') ? _c('td', [item.lawyerOGPA ? _c('div', [_vm._v(_vm._s(item.lawyerOGPA.fullName))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('amountAct') ? _c('td', [((_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.value) === 'ACT' ? _c('span', [_vm._v(_vm._s(item.amount))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('amountAct') ? _c('td', [((_item$type2 = item.type) === null || _item$type2 === void 0 ? void 0 : _item$type2.value) === 'ACT' ? _c('span', [_vm._v(_vm._s(item.cleanAmount))]) : _vm._e()]) : _vm._e(), _vm.canSeeActBonus() ? _c('td', [((_item$type3 = item.type) === null || _item$type3 === void 0 ? void 0 : _item$type3.value) === 'ACT' ? _c('span', [_vm._v(" " + _vm._s(_vm.$helper.util.act.getPercentAndBonusForAct(item, item.contract)) + " ")]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('amountPayout') ? _c('td', [((_item$type4 = item.type) === null || _item$type4 === void 0 ? void 0 : _item$type4.value) === 'PAYOUT' ? _c('span', [_vm._v(_vm._s(item.amount))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('amount') ? _c('td', [_vm._v(" " + _vm._s(item.amount) + " ")]) : _vm._e(), _vm.isVisibleColumn('remainder') ? _c('td', [_vm._v(" " + _vm._s(_vm.getActRemainder(item)) + " ")]) : _vm._e(), _vm.isVisibleColumn('createdBy') ? _c('td', [item.createdBy ? _c('div', [_vm._v(_vm._s(item.createdBy.fullName))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('installment') ? _c('td', [item.installment ? _c('div', [_vm._v(_vm._s(_vm.$helper.getInstallmentName(item.installment)))]) : _vm._e()]) : _vm._e(), _vm.isVisibleColumn('comment') ? _c('td', [item.comment ? _c('div', [_vm._v(_vm._s(item.comment))]) : _vm._e()]) : _vm._e()]);
        }), _c('tr', {
          staticClass: "result-row"
        }, _vm._l(_vm.headers, function (header, i) {
          return _c('td', {
            key: i
          }, [i === 1 ? _c('div', [_vm._v("Всего:")]) : _vm._e(), header.value == 'amountAct' ? _c('div', [_vm._v(" " + _vm._s(_vm.$helper.format.currency(_vm.totalActAmount)) + " ")]) : _vm._e(), header.value == 'cleanAmountAct' ? _c('div', [_vm._v(" " + _vm._s(_vm.$helper.format.currency(_vm.totalCleanActAmount)) + " ")]) : _vm._e(), header.value == 'bonus' && _vm.canSeeActBonus() ? _c('div', [_vm._v(" " + _vm._s(_vm.$helper.format.currency(_vm.totalActBonus)) + " ")]) : _vm._e(), header.value == 'amountPayout' ? _c('div', [_vm._v(" " + _vm._s(_vm.$helper.format.currency(_vm.totalPayoutAmount)) + " ")]) : _vm._e()]);
        }), 0)], 2)];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-bottom-sheet', {
    attrs: {
      "fullscreen": "",
      "scrollable": "",
      "persistent": "",
      "retain-focus": false
    },
    model: {
      value: _vm.dialog.actEdit.modal,
      callback: function ($$v) {
        _vm.$set(_vm.dialog.actEdit, "modal", $$v);
      },
      expression: "dialog.actEdit.modal"
    }
  }, [_c('v-card', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_vm.editedAct ? _c('ActUpdatePage', {
    key: _vm.editedActKey,
    attrs: {
      "id": _vm.editedAct,
      "inPopup": true,
      "nextAct": _vm.nextAct,
      "prevAct": _vm.prevAct
    },
    on: {
      "changeEdited": _vm.changeEdited,
      "closeAndUpdate": _vm.closeEditAndFetch,
      "updated": _vm.forceUpdate,
      "closeEdit": _vm.closeEdit
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }